import RoomElement from './RoomElement'
import FontDefinition from '../../Fonts/FontDefinition'
import RGBA from '../../Fonts/RGBA'
import game from '../../Game/GameInstance'
import PersonIndicator from '../PersonIndicator'
import UrlExecutor from '../../Api/UrlExecutor'
import colorSchemeRepository from '../../Images/ColorSchemeRepository'

let debug = false;
let margin = 50;

let fontDefinitions = {
  event : new FontDefinition('Montserrat').size(20),
  eventTimes : new FontDefinition('Roboto').size(15).weight(700),
};

let black = new RGBA(0);

let colors = {
  black,
  eventTimes : new RGBA(134, 177, 202)
};

let speakerSize = 62;
let speakerMargin = -20;

export default class EventDataRenderer extends RoomElement
{
  constructor() {

    super(...arguments);

    switch(this.room.size) {
      case 'L':
        this.maxSpeakers = 10;
        break;
      case 'M':
        this.maxSpeakers = 6;
        break;
      case 'S':
        this.maxSpeakers = 4;
        break;
    }

    this.overflowElement = new PersonIndicator(speakerSize, []);

  }

  render(ctx) {



    let speakerBox = this.generateSpeakerBox();
    let eventNameBox = this.generateEventNameBox(ctx);
    let eventTimesBox = this.generateEventTimeBox(ctx);

    let spreadBox = this.spreadBoxes([speakerBox, eventNameBox, eventTimesBox]);


    if (debug) {
      this.debugBox(ctx, spreadBox);
      this.debugBox(ctx, speakerBox);
      this.debugBox(ctx, eventNameBox);
      this.debugBox(ctx, eventTimesBox);
    }

    this.renderSpeakers(ctx, speakerBox);

    ctx.fillStyle = colorSchemeRepository.get('foregroundText');
    this.renderEventNameBox(ctx, eventNameBox);
    this.renderEventTimesBox(ctx, eventTimesBox);

  }

  getEventName() {
    return this.room.data.current_event;
  }

  getEventTimes() {
    return this.room.data.current_event_time;
  }

  spreadBoxes(boxes) {

    let spreadBox = this.generateSpreadBox();
    let toSpread = [];

    boxes.forEach(box => {
      if (box.height > 0) {
        toSpread.push(box);
      }
    });

    let height = 0;

    toSpread.forEach((box, index) => {

      if (index > 0 && box.marginTop){
        height += box.marginTop;
      }

      box.y = height;
      height += box.height;

    });

    spreadBox.height = height;

    spreadBox.y = spreadBox.y + (spreadBox.maxHeight - height) / 2;
    boxes.forEach(box => {
      box.y += spreadBox.y;
    });

    return spreadBox;

  }

  renderSpeakers(ctx, box) {

    this.overflowElement.setScale(this.room.zoom);

    let speakers = this.getSpeakers();
    if (speakers.length === 0) {
      return ;
    }

    let x = box.x;
    let y = box.y;

    this.room.hoverMask.remove(new RegExp(/speaker-\d+/));

    let hasOverflow = false;
    let speakerCount = speakers.length;

    if (speakerCount > this.maxSpeakers) {
      speakerCount = this.maxSpeakers - 1;
      hasOverflow = true;
    }

    for (let i = 0; i < speakerCount; i++) {

      let needsRender = false;

      speakers[i].model.setScale(this.room.zoom);
      speakers[i].model.size = (speakerSize) - 4;
      speakers[i].model.width = (speakerSize);
      speakers[i].model.height = (speakerSize);
      speakers[i].model.x = x;

      speakers[i].model.render(speakers[i].model.ctx);

      ctx.drawImage(speakers[i].model.ctx.canvas, this.scale(x), this.scale(y));


      this.room.hoverMask
        .add('speaker-' + i, x, y, speakerSize + (i < speakerCount - 1 ? speakerMargin : 0), speakerSize)
        .over(() => {
          game.setToolTipText(this.room.x + speakers[i].model.x + speakerSize / 2, this.room.y + y + speakerSize, speakers[i].model.getName(), false);
        })
        .out(() => {
          game.setToolTipText(null);
        })
        .click(() => {
          UrlExecutor.execute(speakers[i].model.data.url);
        });

      x += speakerSize + speakerMargin;


    }

    if (hasOverflow) {

      this.overflowElement.width = speakerSize;
      this.overflowElement.height = speakerSize;
      this.overflowElement.size = speakerSize - 4;

      this.overflowElement.setCount(speakers.length - this.maxSpeakers  + 1);
      this.overflowElement.render(this.overflowElement.ctx);
      ctx.drawImage(this.overflowElement.ctx.canvas, this.scale(x), this.scale(y));


      this.room.hoverMask.add('speaker-overflowx', x, y, speakerSize, speakerSize)
        .over(() => {

            this.room.hoverMask.add('speaker-dropdown', x - (game.hoverNameList.width - speakerSize) / 2, y, game.hoverNameList.width, speakerSize + game.hoverNameList.height).out(() => {

              game.showHoverNameList(null);
              this.room.hoverMask.remove(/speaker-dropdown/);

            })
            game.showHoverNameList(this.room.x + x + speakerSize / 2, this.room.y + y + speakerSize, this.getModels(speakers.slice(this.maxSpeakers - 1)));


        });

    }
    else{
      this.room.hoverMask.remove(/speaker-overflow/);
    }



  }

  renderEventNameBox(ctx, box) {

    let eventName = this.getEventName();

    if (!eventName) {
      return;
    }

    ctx.fillStyle = colors.eventName;
    ctx.font = fontDefinitions.event.scale(this.room.zoom);

    this.renderTextBox(ctx, box);

  }

  renderEventTimesBox(ctx, box) {

    let eventTimes = this.getEventTimes();
    if (!eventTimes) {
      return;
    }

    ctx.fillStyle = colorSchemeRepository.get('eventTimeForegroundText');
    ctx.font = fontDefinitions.eventTimes.scale(this.room.zoom);

    this.renderTextBox(ctx, box);

  }

  renderTextBox(ctx, box) {

    box.lines.forEach((line, index) => {
      line = line.join(' ');
      let lineWidth = this.unscale(ctx.measureText(line).width);

      ctx.fillText(line, this.scale(box.x + (box.width - lineWidth) / 2), this.scale(box.y + index * box.lineHeight + box.lineHeight * .7));

    });

  }


  generateSpreadBox() {

    let x = margin;
    let y = 100;
    let width = this.roomWidth() - margin * 2;
    let height = this.roomHeight() - y - margin;

    return { width, height, maxHeight : height, x, y };

  }

  generateSpeakerBox() {

    let speakers = this.getSpeakers();
    if (speakers.length === 0) {
      return {x : 0, y : 0, width : 0, height: 0};
    }

    let height = speakerSize;
    let x = margin;
    let y = 0;

    let speakerCount = speakers.length;
    if (speakerCount > this.maxSpeakers) {
      speakerCount = this.maxSpeakers;
    }

    let width = (speakerSize + speakerMargin) * speakerCount - speakerMargin;
    x = (this.roomWidth() - width) / 2;

    return { x, y, width, height };

  }

  generateEventNameBox(ctx) {

    let eventName = this.getEventName();

    if (!eventName) {
      return {x : 0, y : 0, width : 0, height: 0};
    }

    let width = this.roomWidth() - margin * 2;
    let x = margin;
    let y = 0;

    ctx.font = fontDefinitions.event.scale(1);
    let lineHeight = fontDefinitions.event.getSize() * 1.5;

    let lines = this.fitText(ctx, eventName, width);
    let height = lineHeight * lines.length;

    return { x, y, width, height, lineHeight, lines, marginTop : 15 };

  }

  generateEventTimeBox(ctx) {

    let eventTimes = this.getEventTimes();

    if (!eventTimes) {
      return {x : 0, y : 0, width : 0, height: 0};
    }

    let width = this.roomWidth() - margin * 2;
    let x = margin;
    let y = 0;

    ctx.font = fontDefinitions.eventTimes.scale(1);
    let lineHeight = fontDefinitions.eventTimes.getSize() * 1.5;

    let lines = this.fitText(ctx, eventTimes, width);
    let height = lineHeight * lines.length;

    return { x, y, width, height, lineHeight, lines, marginTop : 5 };

  }


  fitText(ctx, text, maxWidth) {

    let lines = [];
    let words = text.split(/\s/g);
    let wordCount = words.length;
    let currentLine = [];

    for (let i = 0; i < wordCount; i++) {

      let word = words[i];

      let size = ctx.measureText(currentLine.concat([word]).join(' ')).width;

      if (size > maxWidth) {
        lines.push(currentLine);
        currentLine = [];
      }

      currentLine.push(word);

    }

    if (currentLine.length) {
      lines.push(currentLine);
    }

    return lines;

  }

  getModels(speakers) {
    let res = [];
    speakers.forEach(speaker => {
      res.push(speaker.model);
    });
    return res;
  }


  garbageCollect() {

    if (this.overflowElement) {
      this.overflowElement.garbageCollect();
    }

  }

}
